import React, { useRef } from 'react';
import { NativeVideoEffects } from '@/components/video-effects/NativeVideoEffects';
import { useHasVideoEffects } from '@/components/video-effects/VideoEffectsContext';
import { withStillCorsCacheKey } from '@/lib/cover/withStillCorsCacheKey';
// Browser Player only (not the render bundle). HTML5 Video keeps clip-card
// play() on the user gesture; `@remotion/media` resumes AudioContext after
// mount and freezes the clock at 0:00. Explicit `#t` trims each cut because
// Remotion would otherwise cap the fragment to composition duration.
import { Html5Video } from 'remotion';
import { withHtml5VideoFragment } from '@/lib/preview/withHtml5VideoFragment';

export const PreviewIntervalVideo: React.FC<{
  videoUrl: string;
  trimBefore: number;
  trimAfter: number;
  fps: number;
  volume: number | ((frame: number) => number);
  objectFit: 'contain' | 'cover' | 'fill';
  isMuted?: boolean;
  style?: React.CSSProperties;
  onMediaError?: (error: Error) => void;
}> = ({
  videoUrl,
  trimBefore,
  trimAfter,
  fps,
  volume,
  objectFit,
  isMuted = false,
  style,
  onMediaError,
}) => {
  const ref = useRef<HTMLVideoElement>(null);
  const active = useHasVideoEffects();
  const url = active ? withStillCorsCacheKey(videoUrl) : videoUrl;
  return <>
  <Html5Video
    ref={ref}
    crossOrigin={active ? 'anonymous' : undefined}
    src={withHtml5VideoFragment(url, trimBefore, trimAfter, fps)}
    startFrom={trimBefore}
    endAt={trimAfter}
    volume={isMuted ? 0 : volume}
    pauseWhenBuffering
    style={{ width: '100%', height: '100%', objectFit, ...style }}
    onError={onMediaError}
  />
  <NativeVideoEffects videoRef={ref} sourceKey={url} style={{ objectFit, ...style }} />
  </>;
};
